import { useEffect, useState } from "react";
import { Container } from "@mui/material";
import stockService from "../services/stock";
import useStore from "../store/store";
import {
	Text,
	Heading,
	Button,
	UnitsDropdown,
	ArrowDownChip,
} from "../controls";

function AddStock({ setIsOpen, reload }) {
	let [title, setTitle] = useState("");
	let [units, setUnits] = useState("");

	const { token, setErrorMessage, setSuccessMessage, setIsLoading, currObj } =
		useStore((state) => state);

	useEffect(() => {
		if (currObj) setTitle(currObj.title);
	}, [currObj]);

	const createStock = () => {
		currObj ? edit() : create();
	};

	const create = () => {
		setIsLoading(true);
		let data = { title, units };
		stockService.create(token, data).then((r) => {
			if (r.error) {
				setErrorMessage(r.error);
				setIsLoading(false);
				return;
			}
			if (r.data) {
				setSuccessMessage("Data has been added to stocks");
				setIsOpen(false);
				setIsLoading(false);
				clearForm();
				reload();
			}
		});
	};

	const edit = () => {
		let data = { id: currObj._id, title };
		stockService.update(token, data).then((r) => {
			if (r.error) {
				setErrorMessage(r.error);
				setIsLoading(false);
				return;
			}
			if (r.data) {
				setSuccessMessage("Title updated successfully");
				setIsOpen(false);
				clearForm();
				reload();
			}
		});
	};

	const clearForm = () => {
		setTitle("");
		setUnits("");
		setIsOpen(false);
	};

	return (
		<>
			<Container sx={{ overflow: "auto" }}>
				<Heading text="Add Stock" variant="h6" />
				<Text label="Title" value={title} onChange={setTitle} />
				{!currObj && (
					<UnitsDropdown
						placeholder="Units"
						label={currObj ? currObj.units : "Units"}
						value={units}
						onChange={setUnits}
					/>
				)}
				<Button
					icon={<ion-icon name="add-circle-outline"></ion-icon>}
					onClick={createStock}
					text={currObj ? "Update" : "Create"}
				/>
				<ArrowDownChip onClick={clearForm} />
			</Container>
		</>
	);
}

export default AddStock;
